import { Button, styled } from '@mui/material';

export const StyledButton = styled(Button)({
	height: '44px',
	padding: '10px 16px',
	display: 'flex',
	gap: '8px',
	textTransform: 'none',
	fontWeight: '600',
	maxWidth: 'clamp(150px, 12.5vw, 250px)',
});
